(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/store/suspension-slice.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/store/suspension-slice.js');
"use strict";


const {
  gamingPauseDoc = {},
  personalInformationDoc = {}
} = svs.spelpaus.data.model;

const getInitialState = () => ({
  gamingPauseDoc,
  personalInformationDoc,
  hasDataLoaded: false,
  activeSuspensions: [],
  historySuspensions: []
});
const suspensionSlice = RTK.createSlice({
  name: 'suspension',
  initialState: getInitialState(),
  reducers: {
    setHasDataLoaded: (state, action) => {
      state.hasDataLoaded = action.payload;
    },
    setActiveSuspensions: (state, action) => {
      state.activeSuspensions = action.payload;
    },
    setHistorySuspensions: (state, action) => {
      state.historySuspensions = action.payload;
    }
  }
});
svs.spelpaus.store.suspension.actions = suspensionSlice.actions;
svs.spelpaus.store.suspension.reducer = suspensionSlice.reducer;
svs.spelpaus.store.suspension.initialState = getInitialState();

 })(window);